var map = {
	"./dateIcon.png": 2542,
	"./dateIcon.svg": 2805,
	"./hallesche.png": 4640,
	"./levelnine.png": 7888,
	"./sdk.png": 195,
	"./sdkColorBlind.svg": 43,
	"./vmk.svg": 9527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8690;